export function calcProfileDepth(taxProfile) {
  if (!taxProfile) return 0
  const checks = [
    taxProfile.citizenship_status,
    // residency_year_type and spain_residency_status are year-specific —
    // they live in tax_year_profiles, not tax_profiles.
    // ProfilePage passes the merged form object here so these fields
    // are still present and contribute to depth scoring.
    taxProfile.residency_year_type,
    taxProfile.spain_residency_status,
    taxProfile.marital_status,
    taxProfile.foreign_account_band,
    taxProfile.filing_goal,
    taxProfile.urgency_deadline,
  ]
  let score = checks.filter(Boolean).length
  if (taxProfile.income_types?.length) score += 1
  if (taxProfile.major_events?.length) score += 1
  return Math.round((score / 9) * 100)
}